import {
  Avatar,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuDivider,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@garther/ui/components";
import { useI18n } from "@garther/ui/libs";
import { useRouter } from "@tanstack/react-router";
import { ChevronDown, CircleCheckBig, LogOut, ScanLine, User, Wallet } from "lucide-react";

import { useAuthStore } from "@/features/auth/auth.store";
import { trackEngagement } from "@/shared/libs/analytics";
import { firebaseService } from "@/shared/libs/firebase";

export function AuthButton() {
  const { signIn, loggedIn, curUser } = useAuthStore();
  const router = useRouter();
  const { t } = useI18n();

  const handleSignOut = async () => {
    trackEngagement("sign_out", "authentication");
    await firebaseService.signOut();
    router.navigate({ to: "/" });
  };

  if (loggedIn) {
    return (
      <DropdownMenu closeAfterClick>
        <DropdownMenuTrigger asChild>
          <button className="pr-1 w-10 h-9 relative">
            <Avatar
              name={curUser?.fbUser?.email || undefined}
              src={curUser?.profile?.avatar || undefined}
              size={9}
            />
            <div className="absolute right-0 bottom-0 bg-background-primary rounded-full border border-border-light">
              <ChevronDown size={12} strokeWidth={2} />
            </div>
          </button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="right">
          <DropdownMenuItem
            icon={<User size={18} strokeWidth={2} />}
            onClick={() =>
              router.navigate({
                to: "/user/$id/profile",
                params: { id: curUser?.fbUser?.uid || "" }
              })
            }
          >
            {t("navigation.viewProfile")}
          </DropdownMenuItem>

          <DropdownMenuItem
            icon={<Wallet size={18} strokeWidth={2} />}
            onClick={() =>
              router.navigate({
                to: "/user/$id/wallet",
                params: { id: curUser?.fbUser?.uid || "" }
              })
            }
          >
            {t("navigation.wallet")}
          </DropdownMenuItem>

          <DropdownMenuItem
            icon={<ScanLine size={18} strokeWidth={2} />}
            onClick={() => router.navigate({ to: "/ticket/scanner" })}
          >
            Scanner
          </DropdownMenuItem>

          <DropdownMenuDivider />

          <DropdownMenuItem
            icon={<LogOut size={18} strokeWidth={2} />}
            onClick={handleSignOut}
            variant="danger"
          >
            {t("navigation.signOut")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    /* Sign In Button */
    <Button
      onClick={() => {
        trackEngagement("sign_in_click", "authentication");
        signIn();
      }}
      className="flex items-center space-x-1 md:space-x-2 text-responsive-base px-2 py-1.5 md:px-3 md:py-2"
      variant="outline"
    >
      <CircleCheckBig size={16} />
      <span>{t("navigation.login")}</span>
    </Button>
  );
}
